// src/AppRouter.js
import React, {useMemo} from 'react';
import {BrowserRouter as Router, Route, Routes, useSearchParams} from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Header from './components/Header/Header';
import {PATH} from './constants';
import Services from './pages/Services';
import Hiring from './pages/Hiring';
import Contact from './pages/Contact';
import Footer from './components/Footer';
import FAQ from './pages/FAQ/FAQ';
import PolicyUsage from "./pages/FAQ/PolicyUsage";
import PolicyPrivacy from "./pages/FAQ/PolicyPrivacy";
import PolicyFutaBusline from "./pages/FAQ/PolicyFutaBusline";
import TravelInsurance from "./pages/FAQ/TravelInsurance";
import Job from "./pages/Job";
import LinkGuideSHB from "./pages/LinkGuideSHB";
import Download from "./pages/FAQ/Download";
import Guild from "./pages/Guild";
import LinkGuideBIDV from "./pages/LinkGuideBIDV";
import LinkGuideNAPAS from "./pages/LinkGuideNAPAS";
import GuildFutaTicket from "./pages/GuildFutaTicket";

const AppRouter = () => {
	return (
		<Router>
			<Content/>
		</Router>
	);
}

const Content = () => {
	const [params] = useSearchParams();
	const inApp = params.get('inApp');
	const isWebView = useMemo(() => {
		if (inApp) return true;
		if (typeof window === 'undefined') return false;
		if (window.ReactNativeWebView) return true;
		const ua = window.navigator?.userAgent || '';
		// Android System WebView: "; wv". Some in-app browsers include "WebView".
		// Do not match Safari's "Version/17.x" — that is normal desktop/mobile Safari, not a WebView.
		return /; wv\b|\bWebView\b/i.test(ua);
	}, [inApp]);
	return (
		<div className="font-default">
			{!isWebView && <Header/>}
			<Routes>
				<Route path={PATH.HOME} element={<Home/>}/>
				<Route path={PATH.SERVICES} element={<Services/>}/>
				<Route path={PATH.ABOUT} element={<About/>}/>
				<Route path={PATH.HIRING} element={<Hiring/>}/>
				<Route path={`${PATH.HIRING}/:slug`} element={<Job/>}/>
				<Route path={PATH.CONTACT} element={<Contact/>}/>
				<Route path={PATH.GUILD} element={<Guild/>}/>
				<Route path={`${PATH.GUILD}/:menu`} element={<Guild/>}/>
				<Route path={`${PATH.GUILD}/:menu/:subMenu`} element={<Guild/>}/>
				<Route path={`${PATH.GUILD}/:menu/:subMenu/:childMenu`} element={<Guild/>}/>
				<Route path={PATH.FAQ} element={<FAQ/>}/>
				<Route path={PATH.FAQ_INFO} element={<FAQ/>}/>
				<Route path={PATH.FAQ_ACCOUNT} element={<FAQ/>}/>
				<Route path={PATH.FAQ_TOP_UP} element={<FAQ/>}/>
				<Route path={PATH.FAQ_TRANSFER} element={<FAQ/>}/>
				<Route path={PATH.FAQ_INCIDENT} element={<FAQ/>}/>
				<Route path={PATH.FAQ_SAFETY_SECURE} element={<FAQ/>}/>
				<Route path={PATH.POLICY_USAGE} element={<PolicyUsage/>}/>
				<Route path={PATH.POLICY_PRIVACY} element={<PolicyPrivacy/>}/>
				<Route path={PATH.POLICY_FUTA_BUSLINE} element={<PolicyFutaBusline/>}/>
				<Route path={PATH.TRAVEL_INSURANCE} element={<TravelInsurance/>}/>
				<Route path={PATH.LINK_GUIDE_SHB} element={<LinkGuideSHB/>}/>
				<Route path={PATH.LINK_GUIDE_BIDV} element={<LinkGuideBIDV/>}/>
				<Route path={PATH.LINK_GUIDE_NAPAS} element={<LinkGuideNAPAS/>}/>
				<Route path={PATH.FUTA_TICKET_PAYMENT_GUILD} element={<GuildFutaTicket/>}/>
				<Route path={PATH.DOWNLOAD} element={<Download/>}/>
			</Routes>
			{!isWebView && <Footer/>}
		</div>
	)
}

export default AppRouter;
